import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const aadAdminConsent = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.LOGIN.AAD_ADMIN_CONSENT,
    data
  );
};

export default aadAdminConsent;
